<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Tipo richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.tipoRichiedente ? 'Interno' : 'Esterno'"></div>
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Oggetto'" [valueInput]="ctxBodyFascicolo.fascicolo.oggetto"></div>
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Tipologia contratto'" [valueInput]="null"></div>
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Tipologia sanzione'" [valueInput]="null"></div>
  <div labelTextInput class="col-sm-4" [typeLabel]="'date'"
       [labelInput]="'Data provvedimento'" [valueInput]="ctxBodyFascicolo.fascicolo.dataProvvedimento"></div>
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Sospensione cautelare non disciplinare'" [valueInput]="ctxBodyFascicolo.fascicolo.sospensioneCautelareNonDisciplinare ? 'Si' : 'No'"></div>
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Sospensione del rapporto di lavoro'" [valueInput]="ctxBodyFascicolo.fascicolo.sospensioneRapportoDiLavoro ? 'Si' : 'No'"></div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
  <!--<div *ngIf="ctxBodyFascicolo.fascicolo.tipoRichiedente" labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.richiedenteInterno?.nome"></div>
  <div *ngIf="!ctxBodyFascicolo.fascicolo.tipoRichiedente" labelTextInput class="col-sm-3" [typeLabel]="'text'"
       [labelInput]="'Richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.richiedenteEsterno"></div>
  <div labelTextInput class="col-sm-3" [typeLabel]="'date'"
       [labelInput]="'Data emissione'" [valueInput]="ctxBodyFascicolo.fascicolo.dataEmissione"></div>
</div>
<div *ngIf="ctxBodyFascicolo.fascicolo.definito" class="row container_fieldset bloccodati">
  <fieldset class="form-group">
    <legend>Definizione fascicolo</legend>
    <div labelTextInput class="col-sm-4" [typeLabel]="'boolean'"
         [labelInput]="'Definito'" [valueInput]="ctxBodyFascicolo.fascicolo.definito"></div>
    <div labelTextInput class="col-sm-4" [typeLabel]="'date'"
         [labelInput]="'Data definizione'" [valueInput]="ctxBodyFascicolo.fascicolo.dataDefinizione"></div>
    <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
         [labelInput]="'Motivo definizione'"	[valueInput]="ctxBodyFascicolo.fascicolo.motivoDefinizione.label"></div>
  </fieldset>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label for="quesito_richiesta" class="col-sm-12">Quesito/richiesta</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.richiesta }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label for="sintesi_parere" class="col-sm-12">Sintesi parere</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.sintesiParere }}</span>
    </p>
  </div>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>-->
